<template>
  <AuthLayout>
    <div class="portal-header">
      <h1 class="auth-title">{{ $t('authentication.portalTitle') }}</h1>
      <span class="auth-subtitle">{{ $t('authentication.connectToAccess') }}</span>
    </div>

    <div class="auth-submit">
      <div v-on:click="azureLogin()" class="btn btn-outlined-black">
        <span class="sso-label">
          <span class="microsoft-icon"></span>
          <span>{{ $t('authentication.azureadConnection')}}</span>
        </span>
      </div>

      <div class="authentication-divider">
        <div class="login-divider">
          <span>{{ $t('authentication.or')}}</span>
        </div>
      </div>
    </div>

    <div v-if="hasError" class="alert alert-danger" role="alert">
      <ul>
        <div v-if="hasError" translate>
          <div class="margin">
            {{ $t('authentication.errorConnection')}}
          </div>
          <div v-if="!hasAzureAdErrorNoAccount && !hasAzureAdError">
            {{ $t('authentication.errorMessage')}}
          </div>
          <div v-if="hasAzureAdErrorNoAccount">
            {{ $t('authentication.noAzureAdAccount')}}
          </div>
          <div v-if="hasAzureAdError">
            {{ $t('authentication.azureAdError')}}
          </div>
          <div>
            {{ $t('authentication.errorMessage2')}}
          </div>
        </div>
      </ul>
    </div>

    <form name="loginForm" class="form-mib">
      <div class="form-placement">
        <input name="login" class="inputLabelFloat"
               :class="{'mib-not-empty': user.login}"
               v-model="user.login"/>
        <label class="labelFloat">
          <span>
            {{ $t('authentication.email')}}
          </span>
        </label>
      </div>

      <div class="form-placement">
        <input name="pwd" class="inputLabelFloat" type="password"
               :class="{'mib-not-empty': user.password}" v-model="user.password"
               v-if="!showPassword"/>
        <input name="pwdText" class="inputLabelFloat" type="text"
               :class="{'mib-not-empty': user.password}" v-model="user.password"
               v-if="showPassword"/>

        <label class="labelFloat">
          <span>
            {{ $t('authentication.pwd')}}
          </span>
        </label>

        <i class="fal icon icon-medium-size icon-login-eye"
           :class="{'fa-eye': !showPassword,'fa-eye-slash': showPassword}"
           v-on:click.prevent="togglePassword">
        </i>
      </div>

      <div class="forgot-password">
        <a v-on:click="goToResetPwd()" class="btn-ghost-primary">
          <span>{{ $t('authentication.pwdReset')}}</span>
        </a>
      </div>

      <div v-if="!attemptInSecond" class="auth-submit">
        <button v-on:click.prevent="login()" class="btn btn-filled-primary">
          <span v-if="!tryLogin">{{ $t('authentication.connection')}}</span>
          <span v-if="tryLogin"><i class="fal fa-circle-notch fa-spin"
                                   style="margin:0 20px;"></i></span>
        </button>
      </div>

      <div v-if="attemptInSecond" class="auth-submit">
        <button disabled="true" class="btn btn-filled-primary">
          <span>{{$t('authentication.connectionLazyLogin', {'second': attemptInSecond})}}</span>
        </button>
      </div>
    </form>
  </AuthLayout>
</template>

<script>
  import {loginByEmail} from '../api/login'
  import ApiService from '../api/api.config'
  import AuthLayout from '../components/AuthLayout.vue'
  import Cookies from 'js-cookie';
  import { v4 as uuidv4 } from 'uuid';

  export default {
    name: 'Login',
    components: {AuthLayout},
    data() {

      const deviceId = this.$route.query.device_id;
      const extensionId = this.$route.query.extension_id;
      const protocol = this.$route.query.protocol;
      const tabId = this.$route.query.tab_id;
      if (deviceId && (tabId || extensionId && protocol)) {
        let cookieValue =  JSON.stringify(tabId ? {deviceId,tabId} : {deviceId,extensionId,protocol});
        var inFiveMinutes = new Date(new Date().getTime() + 5 * 60 * 1000);
        Cookies.set(
          'AUTH-FOR-EXT',
          btoa(cookieValue),
          { expires: inFiveMinutes , sameSite: 'None', secure: true}
        );
      }
      const hasAzureAdErrorNoAccount = this.$route.query.failure_code === 'no_azure_ad_account';
      const hasAzureAdError = this.$route.query.failure_code === 'azure_ad_error';

      this.connectByCookies()

      if (!Cookies.get('AUTH-DEVICE')) {
        Cookies.set('AUTH-DEVICE', uuidv4(), {expires: 1000})
      }

      return {
        response: [],
        errors: [],
        user: {
          login: '',
          pwd: '',
          id: 0,
        },
        sitekey: '6LdymkwUAAAAAHD8OuwC68Arv6oz4wmAcTl7dvoL',
        showResponse: false,
        badLog: false,
        tryLogin: false,
        attemptInSecond: undefined,
        showPassword: false,
        hasError: hasAzureAdErrorNoAccount || hasAzureAdError,
        hasAzureAdErrorNoAccount: hasAzureAdErrorNoAccount,
        hasAzureAdError: hasAzureAdError,
        retrievedUser: {},
        showRetrievedUser: false
      }
    },
    methods: {
      azureLogin() {
        window.open(ApiService.getApiUrl() + "/azure-ad-sso/login-request" ,"_self");
      },
      login(afterWaiting = false) {
        if (this.interval) {
          this.resetInterval()
        }

        if (!this.user.login || !this.user.password) {
          this.hasError = true
          return
        }

        if(!afterWaiting) {
          this.hasError = false
        }
        loginByEmail(this.user.login, this.user.password)
          .then((response) => {
            this.tryLogin = false
            if (response.data.redirectUrl) {
              this.initCookiesAfterAuthSuccess(response.data.redirectUrl)


              this.redirect(response.data.redirectUrl)
            } else {
              this.hasError = true
            }
          })
          .catch((error) => {
            this.tryLogin = false
            if (error.response.status !== undefined && error.response.status === 500) {
              this.hasError = true
              return
            }
            if (error.response.data <= 12) {
              this.startInterval(error.response.data * 5)
              if (afterWaiting || (!afterWaiting && error.response.message === "0")) {
                this.hasError = true
              }
              if (!afterWaiting && error.response.message > 0) {
                this.hasError = false
              }
            } else {
              if (error.response.data.includes("untrustedip")) {
                this.$router.push({path: "/restricted"})
              }
              if (error.response.data.includes("deactivate")) {
                this.$router.push({path: "/deactivate"})
              }
              this.hasError = true
            }
          })
      },
      connectByCookies() {
        let redirectUrlV2 = Cookies.get("redirectUrlV2");
        if(redirectUrlV2) {
          const redirectUrlV2Host = redirectUrlV2.split("?")[0];
          this.redirect(redirectUrlV2Host)
        }
      },
      goToResetPwd() {
        this.$router.push({path: '/resetPassword'})
      },
      togglePassword() {
        this.showPassword = !this.showPassword
      },

      startInterval(seconds) {
        this.attemptInSecond = seconds
        this.interval = setInterval(() => {
          if (this.attemptInSecond) {
            this.attemptInSecond = this.attemptInSecond - 1
          } else if (this.attemptInSecond === 0) {
            this.attemptLogin()
          }
        }, 1000)
      },

      resetInterval() {
        this.attemptInSecond = undefined
        clearInterval(this.interval)
      },
      attemptLogin() {
        this.resetInterval()
        this.login(true)
      },

      redirect: function(redirectUrl) {
        let prefixOfUrlParam = redirectUrl.indexOf("?") === -1 ? "?" : "&"

        const cookie = Cookies.get('AUTH-FOR-EXT')
        if(cookie) {
          Cookies.remove('AUTH-FOR-EXT');
          const cookieJson = JSON.parse(atob(cookie));
          const deviceId = cookieJson.deviceId;
          const extensionId = cookieJson.extensionId;
          const tabId = cookieJson.tabId;
          const protocol = cookieJson.protocol;
          if(tabId) {
            prefixOfUrlParam+= "device_id=" + deviceId + "&tab_id=" + tabId + "&"
          } else {
            prefixOfUrlParam+= "device_id=" + deviceId + "&extension_id=" + extensionId + "&protocol=" + protocol + "&"
          }
          prefixOfUrlParam+= "isAzure=true&"
        }


        window.location.href = redirectUrl + prefixOfUrlParam + "t=" + Date.now()
      },

      onExpired: function() {
        console.log('Expired')
      },
      initCookiesAfterAuthSuccess(redirectUrl) {
        //remove parameter from redirectUrl
        Cookies.set('redirectUrlV2', redirectUrl.split("?")[0], {expires: 3})
      }
    }
  }
</script>
